<mat-dialog-content class="overflow-y-auto-max-85vh">
    <app-terms-and-conditions></app-terms-and-conditions>
</mat-dialog-content>

<mat-dialog-actions align="end"
    class="sticky-bottom-footer">
    <button mat-button [mat-dialog-close]="" cdkFocusInitial>{{ 'FORM.TERMSDIALOGCLOSE' | transloco }}</button>
</mat-dialog-actions>